export const stringAvatar = (name?: string) => {
  if (name) {
    const splittedName = name.trim().replace(/\s+/g, " ").split(" ");
    try {
      if (splittedName.length > 0 && splittedName[0]) {
        return {
          children:
            splittedName.length > 1
              ? `${splittedName[0][0]?.toUpperCase() ?? ""}${splittedName[1][0]?.toUpperCase() ?? ""}`
              : `${splittedName[0][0]?.toUpperCase() ?? ""}${splittedName[0][1]?.toUpperCase() ?? ""}`,
        };
      }

      return null;
    } catch (error) {
      console.log(name);
      console.error(error);
      return null;
    }
  }
};

export function nameToInitials(name: string): string {
  if (!name) {
    return "";
  }
  const nameParts = name.split(" ").filter(Boolean);
  if (nameParts.length === 0) {
    return "";
  }
  if (nameParts.length === 1) {
    return nameParts[0][0].toUpperCase();
  }
  return `${nameParts[0][0].toUpperCase()}${nameParts[1][0].toUpperCase()}`;
}
